var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "info-wrap agreement-info"
  }, [_c('h2', [_vm._v("Agreement")]), _c('p', [_vm._v("Please read the agreements for the plans you enrolled in.")]), _vm._l(_vm.texts, function (text, index) {
    return _c('div', {
      key: index,
      staticClass: "agreement-text"
    }, [text.title ? _c('h3', [_vm._v(_vm._s(text.title))]) : _vm._e(), _c('div', {
      staticClass: "agreement-body",
      domProps: {
        "innerHTML": _vm._s(text.body)
      }
    })]);
  }), _c('div', {
    staticClass: "row justify-content-end mt-3"
  }, [_c('div', {
    staticClass: "col-xxl-3 col-xl-3 col-lg-3 col-md-6"
  }, [_c('review-next-note', {
    attrs: {
      "action": "Next"
    }
  }), _c('button', {
    staticClass: "univ-btn",
    staticStyle: {
      "max-width": "100% !important"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('next');
      }
    }
  }, [_vm._v("Next")])], 1)])], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }